import HTTP from "../../http";

const CART_ENDPOINT = "/carts";
const CHECKOUT_CART_ENDPOINT = "/checkout";

export async function checkoutCart(cart) {
  return await HTTP.put(
    CART_ENDPOINT + CHECKOUT_CART_ENDPOINT,
    { cart },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
